import { Injectable } from "@angular/core";
import { StateService } from "../state"
import { Observable } from "rxjs";
import { eventEmitter } from "@app/shared/utils/event-emitter";
import { CompanyService } from "./company.service";
import { AuthenticationService } from "./authentication.service";

const TENANT_STORAGE = 'TENANTS';
const INSURANCE_CODE = 'INSURANCE_CODE';
@Injectable({
  providedIn: 'root'
})
export class InsuranceCodeStateService{
  insuranceCode: string = undefined;
  tenant: any;
  getInsuranceCode(): string {
    if (!this.insuranceCode && this.insuranceCode !== '') {
      this.insuranceCode = localStorage.getItem(`${INSURANCE_CODE}_${this.getTaxCode()}`);
    }
    return this.insuranceCode;
  }

  setInsuranceCode(code: any) {
    this.insuranceCode = code;
    eventEmitter.emit('isurranceCodes:set', code);
    localStorage.setItem(`${INSURANCE_CODE}_${this.getTaxCode()}`, code);
  }

  clearInsuranceCode(){
    localStorage.removeItem(`${INSURANCE_CODE}_${this.getTaxCode()}`);
    this.insuranceCode = undefined;
    this.tenant = undefined;
  }

  onInsuranceCodeChange(handler: any): void {
    eventEmitter.on("isurranceCodes:set", (code) => {
      handler(code);
    })
  }

  private getTaxCode(){
    var tenant = this.getTenantInfo();
    var taxCode = tenant.companyInfo.taxCode;
    return taxCode;
  }

  private getTenantInfo(){
    if(!this.tenant){
      return this.tenant = JSON.parse(localStorage.getItem(TENANT_STORAGE));
    }

    return this.tenant;
  }
}